module.exports = __webpack_public_path__ + "2f1ce0c3da305e74ede0d7f4fe57f52a.pdf";